<template>
  <div class="photo-box">
    <div class="box">
      <div class="photo">
        <div class="img" v-if="data.portfolio">
          <img
            v-fadeInImageLoading="
              data.portfolio[0]
                ? data.portfolio[0].thumbnailFullPath
                : data.mainImage
            "
            :style="{
              height: data.portfolio[0].direction === 'width' ? '120%' : 'auto',
              width: data.portfolio[0].direction === 'height' ? '120%' : 'auto'
            }"
          />
        </div>
        <!--<div  v-else class="pre-img"></div>-->
        <div class="rate">
          <div class="rate-box" v-show="grade > 0" v-if="rateImg">
            <img
              v-for="num in [1, 2, 3, 4, 5]"
              :src="num <= grade ? rateImg : unRateImg"
              :key="num"
            />
          </div>
          <div class="number">{{ grade }}</div>
        </div>
      </div>
      <div class="photographer-name">
        <span class="under-bar">{{ data.name }}</span>
      </div>
      <div class="price">
        <span class="under-bar">
          <span class="number"
            ><span v-currency="data.currencyUnit"></span>{{ data.price }}</span
          >
          <span class="hour">/ hour</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import mixinPrice from '@/mixin/price'
import mixCommon from '@/mixin/common'

export default {
  mixins: [mixinPrice, mixCommon],
  name: 'photo-box',
  props: {
    data: {
      default: () => ({}),
      type: [Array, Object]
    }
  },
  data() {
    return {
      rateImg: require('@/assets/images/etc/rated.png'),
      unRateImg: require('@/assets/images/etc/unrated-outline.png'),
      mainPhoto: '',
      mainPhotoCheck: false
    }
  },
  created() {
    // console.log(this.data)
    // this.mainImage()
  },
  updated() {
    // this.mainImage()
  },
  computed: {
    grade() {
      // console.log("this.data.rating:", this.data.rating.toString().length);
      return this.data.rating.toString().length < 2
        ? this.data.rating + '.0'
        : this.data.rating
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.photo-box {
  /*border: 1px solid red;*/
  width: 240px;
  height: 397px;
  display: block;

  .box {
    position: relative;
    width: inherit;
    height: inherit;
    display: block;
    cursor: pointer;

    .photo {
      width: inherit;
      height: 321px;
      position: relative;
      overflow: hidden;
      display: block;

      .img {
        width: 100%;
        height: 100%;
        animation: photoLoad;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.6s ease-in-out;
        position: relative;

        img {
          height: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          object-fit: cover;
        }
      }

      @keyframes photoLoad {
        from {
          opacity: 0;
        }

        to {
          opacity: 1;
        }
      }

      .rate {
        position: absolute;
        left: 0;
        bottom: 0;
        background-color: #ffffff;
        height: 45px;
        min-width: 45px;
        /*border: 1px dotted red;*/
        .number {
          position: relative;
          float: right;
          width: 45px;
          height: 45px;
          text-align: center;
          line-height: 45px;
          font-family: Georgia;
          font-size: 16px;
          font-weight: bold;
          font-style: italic;
          font-stretch: normal;
          letter-spacing: normal;
          /*border: 1px solid red;*/
        }

        .rate-box {
          overflow: hidden;
          visibility: hidden;
          opacity: 0;
          width: 0;
          float: left;
          /*border: 1px solid green;*/
          position: relative;
          margin: 14px auto auto 3px;
          /*min-width: 115px;*/
          height: 13px;
          transition: all 0.3s;

          img {
            display: inline;
            margin: 0 0 0 0;
            width: 13px;
            height: 12px;
          }
        }
      }
    }

    .photographer-name {
      position: relative;
      width: auto;
      margin: 9px 0 0 0;
      /*border: 1px solid red;*/
      height: 26px;
      font-size: 16px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 1px;
      color: #000000;
      /*.under-bar {*/
      /*width: 100%;*/
      /*height: 16px;*/
      /*opacity: 0.2;*/
      /*background-color: #ff0000;*/
      /*}*/
    }

    .price {
      position: relative;
      width: auto;
      /*border: 1px solid green;*/
      height: 26px;

      .number {
        font-size: 16px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: left;
        color: #000000;
      }

      .hour {
        font-size: 16px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: left;
        color: #000000;
      }
    }

    .under-bar {
      position: relative;

      &:before {
        content: '';
        height: 16px;
        background-color: #ff0000;
        position: absolute;
        bottom: -3px;
        opacity: 0;
        left: 0;
        width: 0;
      }
    }

    &:hover {
      .photo .rate .rate-box {
        visibility: visible;
        opacity: 1;
        width: 70px;
      }

      .photo .img {
        transform: scale(1.2);
      }

      .photographer-name {
      }

      /*.under-bar {*/
      /*visibility: visible;*/
      /*width: 100%;*/
      /*opacity: 0.2;*/
      /*!*transition: width 1s ease-in-out;*!*/
      /*}*/

      .under-bar {
        &:before {
          content: '';
          width: 103%;
          opacity: 0.2;
          transition: all 0.2s ease-in-out;
        }
      }
    }
  }
}
</style>
